/**
 * AI Check API のベース URL 解決（client-safe）。
 *
 * ルート C′（frontend 静的化 + 別オリジン API）では、静的 frontend から
 * API サーバへクロスオリジンでアクセスする。ビルド時に
 * `NEXT_PUBLIC_AICHECK_API_BASE_URL`（例: https://api-aicheck.example.com）を
 * 指定すると、相対 `/api/...` パスがその絶対 URL に解決される。
 *
 * 未設定時は相対パスのまま返すため、現行の同一オリジン構成
 * （Coolify 単一コンテナ / ローカル開発）では挙動が変わらない。
 */

const RAW_BASE = process.env.NEXT_PUBLIC_AICHECK_API_BASE_URL?.trim() ?? "";

/** 末尾スラッシュを除去した API ベース URL。同一オリジン構成では空文字。 */
export const API_BASE_URL = RAW_BASE.replace(/\/+$/, "");

/**
 * `/api/...` 形式の相対パスを、設定に応じて絶対 URL へ解決する。
 * ベース URL 未設定時は入力をそのまま返す。
 */
export function apiUrl(path: string): string {
  if (!API_BASE_URL) return path;
  if (/^https?:\/\//.test(path)) return path;
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
